// Copyright (c) RoochNetwork
// SPDX-License-Identifier: Apache-2.0

// This file is generated by genversion.mjs. Do not edit it directly.

export const PACKAGE_VERSION = '0.4.0'
export const TARGETED_RPC_VERSION = '0.11.0'
